import styles from "./button.module.css";
import Icon from "./../../icons/icon";

const Button = ({ children }) => {
  return (
    <div className={styles.button}>
      <p>{children}</p>
      <Icon type="Arrow" />
    </div>
  );
};

export default Button;
